// 预算材料dlg组件

const budgetMaterialDlg = {
  namespaced: true,

  state: {
    dlgShow: false,

    postParam: {},

    list: [],
  },

  getters: {
    dlgShow: state => state.dlgShow,

    postParam: state => state.postParam,

    list: state => state.list
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },

    SET_POSTPARAM: (state, val) => {
      state.postParam = val
    },

    SET_LIST: (state, val) => {
      state.list = val
    },

  },

  actions: {

  }
}

export default budgetMaterialDlg
